import { InputHTMLAttributes } from 'react';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg';
  error?: boolean;
}

export const Input = ({
  size = 'md',
  error = false,
  className = '',
  ...props
}: InputProps) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-sm',
    md: 'px-3 py-2 text-sm',
    lg: 'px-4 py-3 text-base'
  };

  const baseClasses = 'w-full rounded-lg border bg-surface-card text-text-primary placeholder-text-tertiary focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200';

  const borderColor = error ? 'border-red-500' : 'border-slate-700/50';

  return (
    <input
      className={`${baseClasses} ${sizeClasses[size]} ${borderColor} ${className}`}
      {...props}
    />
  );
};